import httpStatus from "@/helper/hc-request/lib/utils/httpStatus";
import store from "@/store";
import mapHelper from "@/store/modules/common/map-helper";

export default {
  getInterceptor(instance) {
    instance.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        const originalConfig = error.config;
        if (error.response) {
          if (error.response.status === httpStatus.UNAUTHORIZED && !originalConfig._retry) {
            originalConfig._retry = true;
            
            try {
              await store.dispatch(mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.refreshToken)

              let newToken = store.getters[mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.getToken]
              //let newRefreshToken = store.getters[mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.getRefreshToken]
            
              originalConfig.headers['Authorization'] = 'Bearer '+newToken
              //originalConfig.headers['Refreshtoken'] = newRefreshToken

              return instance(originalConfig);
            } catch (_error) {
              /*Si falla la obtencion del refreshtoken, se cierra la sesion */
              store.dispatch(mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.setExpired)
              if (_error.response && _error.response.data) {
                return Promise.reject(_error.response.data);
              }
              return Promise.reject(_error);
            }

          }

          if (error.response.status !== httpStatus.SUCCESS) {
            return Promise.reject(error.response.data);
          }
        }
        return Promise.reject(error);
      }
    );
    return instance
  }
}